import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const AssessmentSkeleton: React.FC = () => (
  <div className="min-h-screen bg-white py-4 md:py-8">
    <div className="container mx-auto px-4 max-w-6xl">
      {/* Header skeleton */}
      <Skeleton className="h-8 w-48 mx-auto mb-8" />
      
      {/* Instructions card skeleton */}
      <div className="max-w-2xl mx-auto">
        <div className="bg-white border border-gray-200 rounded-lg p-6 md:p-12 shadow-xs">
          <div className="text-center space-y-4">
            <Skeleton className="h-8 w-3/4 mx-auto" />
            <Skeleton className="h-5 w-2/3 mx-auto" />
            <Skeleton className="h-4 w-1/2 mx-auto" />
          </div>
          <div className="text-center mt-8 md:mt-16">
            <Skeleton className="h-12 w-48 mx-auto rounded-md" />
          </div>
        </div>
      </div>
    </div>
  </div>
);
